export type ReducerState = {
  byPartner: Record<string, { adSpend: number | null }>;
};

export const initialState: ReducerState = {
  byPartner: {},
};

export type ReducerAction = {
  type: 'ad_spend_changed';
  payload: {
    partner: string;
    adSpend: ReducerState['byPartner'][string]['adSpend'];
  };
};

export const reducer = (
  state: ReducerState,
  action: ReducerAction
): ReducerState => {
  switch (action.type) {
    case 'ad_spend_changed': {
      return {
        ...state,
        byPartner: {
          ...state.byPartner,
          [action.payload.partner]: {
            ...state.byPartner[action.payload.partner],
            adSpend: action.payload.adSpend,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};
